import { __extends } from "tslib";
import * as React from 'react';
import { namespacedClassnames } from '../../common/namespace-classes';
import { UnControlled as CodeMirror } from 'react-codemirror2';
import { getCodeEditorUserInputSelection } from './code-editor-utils';
var maybeRequireLanguageModes = (function () {
    var required = false;
    return function () {
        if (!required) {
            // tslint:disable-next-line:no-var-require
            require('codemirror/mode/htmlmixed/htmlmixed');
            require('codemirror/mode/css/css');
            require('codemirror/mode/clike/clike');
            require('codemirror/mode/shell/shell');
            require('codemirror/mode/python/python');
            require('codemirror/mode/sql/sql');
            require('codemirror/mode/markdown/markdown');
        }
        required = true;
    };
})();
var maybeRequirePlaceholder = (function () {
    var required = false;
    return function () {
        if (!required) {
            require('codemirror/addon/display/placeholder');
        }
        required = true;
    };
})();
var CodeEditor = /** @class */ (function (_super) {
    __extends(CodeEditor, _super);
    function CodeEditor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isFocused: false
        };
        _this.onChangeHandler = function (_, __, value) {
            _this.props.onChange(value);
        };
        _this.handleFocus = function () {
            _this.setState({ isFocused: true });
            if (_this.props.onFocus) {
                _this.props.onFocus();
            }
        };
        _this.handleBlur = function () {
            _this.setState({ isFocused: false });
            if (_this.props.onBlur) {
                _this.props.onBlur();
            }
        };
        _this.handleKeyDown = function (_, e) {
            if (_this.props.onKeyDown) {
                _this.props.onKeyDown(e);
            }
        };
        _this.getCodeMirrorMode = function () {
            var mode = _this.props.mode;
            switch (mode) {
                case 'html':
                    return 'htmlmixed';
                case 'java':
                    return 'text/x-java';
                case 'scala':
                    return 'text/x-scala';
                case 'sql':
                    return 'text/x-sql';
                case 'json':
                    return { name: 'javascript', json: true };
                default:
                    return mode;
            }
        };
        _this.handleSelection = function (editor, data) {
            if (_this.props.onSelect && data) {
                var sel = getCodeEditorUserInputSelection(editor, data);
                _this.props.onSelect(sel);
            }
        };
        return _this;
    }
    CodeEditor.prototype.componentWillMount = function () {
        maybeRequireLanguageModes();
        if (this.props.placeholder) {
            maybeRequirePlaceholder();
        }
    };
    CodeEditor.prototype.render = function () {
        var props = this.props;
        var classNames = namespacedClassnames('code-editor', { 'has-focus': this.state.isFocused });
        var options = {
            mode: this.getCodeMirrorMode(),
            lineNumbers: true,
            placeholder: this.props.placeholder || ''
        };
        return (React.createElement("div", { className: classNames },
            React.createElement(CodeMirror, { value: props.value, onChange: this.onChangeHandler, options: options, autoCursor: false, onFocus: this.handleFocus, onBlur: this.handleBlur, onKeyDown: this.handleKeyDown, onSelection: this.handleSelection, autoFocus: props.autoFocus })));
    };
    return CodeEditor;
}(React.PureComponent));
export { CodeEditor };
//# sourceMappingURL=code-editor.js.map